import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InPurchasesService } from '../../services/inventory/in-purchases.service';
import { DataService } from '../../services/data.service';
import { InProductsService } from '../../services/inventory/in-products.service';
import { IAlternateunit, IProduct_MasterView, Product_MasterView_Model, Alternateunit_Model } from '../../interface/Product_MasterView'
export interface DeleteItem {
  title: string;
}
@Component({
  selector: 'app-deleteitem',
  templateUrl: './deleteitem.component.html',
  styleUrls: ['./deleteitem.component.css']
})
export class DeleteitemComponent extends DialogComponent<DeleteItem, boolean> implements DeleteItem, OnInit {
  title: string;

  model: IProduct_MasterView;
  isEdit: boolean = false;
  isLoaded: boolean = true;
  isinitialLoad: boolean = true;
  Alternateunit: IAlternateunit
  constructor(dialogService: DialogService,
    private ips: InPurchasesService,
    private ds: DataService,
    private pds: InProductsService) { super(dialogService); }

  ngOnInit() {
    this.isLoaded = true
    this.isinitialLoad = true
    this.model = new Product_MasterView_Model();
    this.Alternateunit = new Alternateunit_Model();
    this.clear()
  }
  getItembyBarcode(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.isLoaded = false;
      var FilterBarcode = {
        ItemType: this.ds.Settings.ItemTypeId,
        Barcode: this.model.Barcode,
        SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
        Branch: this.ds.Settings.BranchId,
        Location: this.ds.Settings.LocationId
      };

      this.pds.GetItem_for_DeleteItem(FilterBarcode).subscribe(res => {
        if (res.Success) {
          this.model = res.data;
          this.model.ShortName = res.data.UnitName
          this.isLoaded = true
          this.isinitialLoad = false
        } else {
        }

      }, (err) => console.error(err),
        () => {
          this.isLoaded = true;
        })
    }
  }
  deleteItem() {
    this.isLoaded = false
    var r = confirm("Do you want to delete this barcode? ");
    if (r == true) {
      this.pds.Delete_Item(this.model.Barcode).subscribe(res => {
        if (res.Success) {

          alert(res.data.Message)
          this.isLoaded = true;
          this.model = new Product_MasterView_Model
          document.getElementById("Barcode").focus();
          this.isinitialLoad = true
        } else {
          alert(res.error.UserMsg)
        }

      }, (err) => console.error(err),
        () => {

          this.isLoaded = true;
        })
    }
    else {
      this.isLoaded = true
    }
  }
  clear() {
    this.model = new Product_MasterView_Model
    document.getElementById("Barcode").focus();
  }
  close(): void {
    this.dialogService.removeDialog(this);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/deleteitem/deleteitem.component.ts